module.exports = __webpack_public_path__ + "static/media/react-native.563425e8.png";